<template>
  <div class="work-plan">
    <el-form :model="addParams" :rules="rules" ref="addForm">
      <el-form-item label="" :show-message="false" prop="content" class="plan-content" v-if="targetType != 'business' && targetType != 'contract'">
        <el-input type="textarea"
          :autosize="{ minRows: 5, maxRows: 8}"
          placeholder="请输入需要完成的计划内容"
          :maxlength="1000"
          show-word-limit
          v-model="addParams.content">
        </el-input>
      </el-form-item>
      <At v-else :members="members" name-key="nickName">
        <template slot="item" slot-scope="s">
          <span v-text="s.item.nickName"></span>
        </template>
        <div class="msg-box">
          <div id="workPlanContentInfo" class="msgInfo" ref="workPlanContentInfo" contenteditable></div>
          <p class="word-number"><span
            :style="addParams.content.length > 1000 ? 'color: red' : ''">{{ addParams.content.length }}</span> / 1000
          </p>
        </div>
      </At>
      <el-row>
        <el-col :xs="24" :md="5" :lg="5" align="right">
          <el-form-item prop="executeUserId">
            <UserSelect v-model="addParams.executeUserId" placeholder="请选择执行人"></UserSelect>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="5" :offset="1" :lg="4" align="right">
          <el-form-item prop="deadline">
            <el-date-picker
              v-model="addParams.deadline"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:00"
              placeholder="选择截止时间">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="3" :lg="3" :offset="11" align="right">
          <el-button v-if="clueStatus === 'follow_up'" type="primary" icon="el-icon-edit" style="vertical-align: top;" @click="createOrUpdateWorkPlan(1)"
                     :disabled="!targetId || !targetType || addParams.content.length <= 0 ">创建
          </el-button>
        </el-col>
      </el-row>
    </el-form>
    <div style="height: 473px;">
      <el-scrollbar class="work-plan-list">
        <div v-infinite-scroll="queryWorkPlanListByPage" :infinite-scroll-disabled="workPlanDisabled" style="padding-right: 15px;">
          <el-card v-for="(item,index) in workPlanList" :key="index" style="margin-top: 10px">
            <div class="planInfo">
              <div>
                <el-button v-if="item.canEditFlag && item.planStatus === 1" type="text" class="planBtn" @click="cancelPlan(item)">取消</el-button>
                <el-button type="text" class="planBtn" style="margin-right: 15px" @click="openPlanDetail(item, 1)">详情</el-button>
                <el-button v-if="item.canCompleteFlag && item.planStatus === 1" type="text" class="planBtn" @click="openPlanDetail(item, 2)">完成</el-button>
                <el-button v-if="item.canEditFlag && item.planStatus === 1" type="text" class="planBtn" @click="editPlan(item)">编辑</el-button>
              </div>
              <!-- 计划状态 1-进行中 2-已完成 3-已取消 -->
              <div :class="item.statusClass">{{item.planStatusDesc}}</div>
              <div :class="item.planStatus === 1 ? 'planContent' : 'planContent completedContent'">{{item.plainContent}}</div>
              <el-row class="contentInfo">
                <el-col :span="2">执行人</el-col>
                <el-col :span="10" align="left">{{item.executeUserNickName}}</el-col>
              </el-row>
              <el-row v-if="item.planStatus === 2" class="contentInfo">
                <el-col :span="2">完成时间</el-col>
                <el-col :span="10" align="left" :class="item.overdueFlag ? 'redColor' : ''">{{item.completeTime}}</el-col>
              </el-row>
              <el-row v-else class="contentInfo">
                <el-col :span="2">截止时间</el-col>
                <el-col :span="10" align="left" :class="item.overdueFlag ? 'redColor' : ''">{{item.deadline}}</el-col>
              </el-row>
            </div>
          </el-card>
        </div>
        <p v-if="listLoading" class="tip">加载中...</p>
        <p v-if="noMore" class="tip">{{workPlanList.length > 0 ? "没有更多了" : "暂无数据"}}</p>
      </el-scrollbar>
    </div>
    <el-dialog class="work-plan" title="编辑计划" :visible.sync="editPlanVisible" width="700px" :close-on-click-modal="false" append-to-body>
      <el-form :model="editParams" :rules="rules" ref="editForm">
        <el-form-item label="" :show-message="false" prop="content" class="plan-content" v-if="targetType != 'business' && targetType != 'contract'">
          <el-input type="textarea"
                    :autosize="{ minRows: 5, maxRows: 8}"
                    placeholder="请输入需要完成的计划内容"
                    :maxlength="1000"
                    show-word-limit
                    v-model="editParams.content">
          </el-input>
        </el-form-item>
        <At v-else :members="members" name-key="nickName">
          <template slot="item" slot-scope="s">
            <span v-text="s.item.nickName"></span>
          </template>
          <div class="msg-box">
            <div id="workPlanContentInfoEdit" class="msgInfo" ref="workPlanContentInfoEdit" contenteditable></div>
            <p class="word-number"><span
              :style="editParams.content.length > 1000 ? 'color: red' : ''">{{ editParams.content.length }}</span> / 1000
            </p>
          </div>
        </At>
        <el-row>
          <el-col :xs="24" :md="8" :lg="8" align="right">
            <el-form-item prop="executeUserId">
              <UserSelect v-model="editParams.executeUserId" placeholder="请选择执行人"></UserSelect>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="8" :offset="1" :lg="8" align="right">
            <el-form-item prop="deadline">
              <el-date-picker
                v-model="editParams.deadline"
                type="datetime"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm:00"
                placeholder="选择截止时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button @click="cancelEdit">取消</el-button>
          <el-button type="primary" @click="createOrUpdateWorkPlan(2)">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog class="work-plan" :title="detailOptType === 1 ? '计划详情' : '完成计划'" :visible.sync="planDetailVisible" width="800px" :close-on-click-modal="detailModalClose"  append-to-body>
      <el-form :model="detailParams" ref="detailForm" label-width="80px">
        <p class="card-title">计划信息</p>
        <div class="item-info">
            <el-form-item label="来源:">
              <span style="margin-right: 10px">{{ planDetail.targetTypeDesc }}</span>
              <el-link type="primary" :underline="false" @click="toTargetDetail(planDetail.targetId, planDetail.targetType)">
                {{ planDetail.targetName }}
              </el-link>
            </el-form-item>
            <el-form-item label="计划描述:">{{ planDetail.plainContent }}</el-form-item>
            <el-form-item label="计划状态:">{{ planDetail.planStatusDesc }}</el-form-item>
            <el-form-item label="截止时间:" :class="planDetail.overdueFlag ? 'redColor' : ''">{{ planDetail.deadline }}</el-form-item>
            <el-form-item label="是否超期:" :class="planDetail.overdueFlag ? 'redColor' : ''">{{ planDetail.overdueFlag ? '是' : '否' }}</el-form-item>
            <el-form-item label="创建人:">{{ planDetail.createUserNickName }}</el-form-item>
            <el-form-item label="创建时间:">{{ planDetail.createTime }}</el-form-item>
        </div>
        <p class="card-title" style="margin-top: 20px;">执行信息</p>
        <div class="item-info">
          <el-form-item label="执行人:">{{ planDetail.executeUserNickName }}</el-form-item>
          <el-form-item v-if="planDetail.planStatus === 2" label="完成时间:" :class="planDetail.overdueFlag ? 'redColor' : ''">{{ planDetail.completeTime }}</el-form-item>
          <el-form-item v-if="planDetail.executeContent || detailOptType === 2" label="补充描述:">
            <el-input v-if="detailOptType === 2"
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 5}"
            :maxlength="1000"
            show-word-limit
            v-model="detailParams.executeContent"
            placeholder="请输入补充描述，非必填"
            clearable/>
            <span v-else class="value">{{planDetail.executeContent}}</span></el-form-item>
          <el-form-item label="" style="margin-top: 15px;">
            <FileUpload v-if="detailOptType === 2" v-model="detailParams.attachmentFileIds" :limit="5" :readOnly="false" @on-change="handleFileChange"></FileUpload>
            <FileUpload v-else v-model="planDetail.attachmentFileObjs" :limit="5" :readOnly="true"></FileUpload>
          </el-form-item>
        </div>
      </el-form>
      <span v-if="detailOptType === 2" slot="footer" class="dialog-footer">
          <el-button @click="cancelComplete">取消</el-button>
          <el-button type="primary" @click="confirmComplete">确认</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import {saveWorkPlan, workPlanListByPage, workPlanDetail, completeWorkPlan, cancelWorkPlan} from "@/api/crm/workPlan";
import {queryAtList} from "@/api/crm/follow";
import FileUpload from "@/views/crm/components/fileUpload";
import UserSelect from "@/views/crm/components/userSelect";
import At from 'vue-at'
import {mapState} from "vuex";
import {businessTargetTypeToPath} from "@/utils/crm";

export default {
  name: "workPlan",
  props: {
    targetId: {},
    targetType: {},
    managerId: {},
    clueStatus: {
      type: String,
      default: 'follow_up'
    }
  },
  data () {
    return {
      members: [],
      workPlanList: [],
      listLoading: false,
      noMore: false,
      rules: {
        content: [
          {required: true, message: '请输入内容', trigger: 'change'},
          {max: 1000, message: '长度过长', trigger: 'change'}
        ],
        executeUserId: [
          {required: true, message: '请选择执行人', trigger: 'change'}
        ],
        deadline: [
          {required: true, message: '请选择截止日期', trigger: 'change'}
        ]
      },
      addParams: {
        targetId: null,
        targetType: null,
        executeUserId: null,
        content: '',
        contentType: null,
        deadline: null
      },
      editParams: {
        planId: null,
        executeUserId: null,
        content: '',
        contentType: null,
        deadline: null
      },
      detailParams: {
        planId: null,
        executeContent: '',
        attachmentFileIds: null
      },
      editPlanVisible: false,
      planDetailVisible: false,
      detailModalClose: false,
      planDetail: {},
      detailOptType: 1, // 1-查看详情 2-完成计划
      // 查询参数
      queryParams: {
        pageNum: 0,
        pageSize: 10,
        targetId: null,
        targetType: null
      },
    };
  },
  components: {
    FileUpload,
    UserSelect,
    At
  },
  mounted () {
    this.addParams.targetId = this.targetId;
    this.addParams.targetType = this.targetType;

    this.queryParams.targetId = this.targetId;
    this.queryParams.targetType = this.targetType;
    this.queryParams.pageNum = 0

    this.addParams.executeUserId = this.managerId

    if (this.targetType == 'business' || this.targetType == 'contract') {
      this.queryAtList()
      setInterval(() => {
        if (!this.editPlanVisible && document.getElementById('workPlanContentInfo')) {
          let content = document.getElementById('workPlanContentInfo').innerText
          if (this.addParams.content != content) {
            this.addParams.content = content
          }
        }
        if (this.editPlanVisible && document.getElementById('workPlanContentInfoEdit')) {
          let content = document.getElementById('workPlanContentInfoEdit').innerText
          if (this.editParams.content != content) {
            this.editParams.content = content
          }
        }
      }, 100)
    }
    this.queryWorkPlanListByPage();
  },
  watch: {
    targetId (val) {
      this.addParams.targetId = this.targetId;
      this.queryParams.targetId = this.targetId;
      if (!val) {
        this.addParams.content = "";
        this.resetForm("addForm");
      }
    },
    targetType (val) {
      this.addParams.targetType = this.targetType;
      this.queryParams.targetType = this.targetType;
    },
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    }),
    workPlanDisabled() {
      return this.listLoading || this.noMore
    }
  },
  methods: {
    // 查询@人员列表
    queryAtList () {
      queryAtList({
        targetId: this.targetId,
        targetType: this.targetType,
      }).then(response => {
        this.members = response.data || []
      })
    },
    refreshWorkPlanList () {
      this.queryParams.pageNum = 0
      this.noMore = false
      this.workPlanList = []
      this.queryWorkPlanListByPage()
    },
    queryWorkPlanListByPage () {
      this.queryParams.pageNum++
      this.listLoading = true
      workPlanListByPage(this.queryParams).then(response => {
        let dataList = response.rows || []
        dataList.forEach(item => {
          // 计划状态 1-进行中 2-已完成 3-已取消
          if (item.planStatus === 1) {
            item.statusClass = 'status-btn statusExecuting'
          } else if (item.planStatus === 2) {
            item.statusClass = 'status-btn statusCompleted'
          } else if (item.planStatus === 3) {
            item.statusClass = 'status-btn statusCanceled'
          }
        })
        this.workPlanList = this.workPlanList.concat(dataList || [])
        if (!dataList || dataList.length < this.queryParams.pageSize || response.total === this.queryParams.pageSize) {
          // 查完了
          this.noMore = true
        }
      }).catch(error => {
        this.listLoading = false
        this.noMore = true
      }).finally(() => this.listLoading = false)
    },
    createOrUpdateWorkPlan (optType) {
      let formRef = null
      let optParam = null
      let eleId = null
      // 1-新增 2-编辑
      if (optType === 1) {
        optParam = this.addParams
        formRef = 'addForm'
        eleId = 'workPlanContentInfo'
      } else {
        optParam = this.editParams
        formRef = 'editForm';
        eleId = 'workPlanContentInfoEdit'
      }
      if (optParam.content.length > 1000) {
        this.msgWarning("工作计划内容不能超过1000个字符");
        return
      }
      this.$refs[formRef].validate((valid) => {
        if (valid) {
          const loading = this.$loading({lock: true, text: '加载中', spinner: 'el-icon-loading'});
          let params = JSON.parse(JSON.stringify(optParam));
          params.contentType = 1 // 默认为字符串类型
          if (this.targetType == 'business' || this.targetType == 'contract') {
            const stringList = optParam.content.split(" ")
            let infoList = stringList.reduce((result, item) => {
              if (item.length) {
                if (item.indexOf('@') > -1) {
                  let userNameList = item.split("@")
                  new Set(userNameList).forEach(userName => {
                    let index = this.members.findIndex(user => user.nickName === userName)
                    if (index > -1) {
                      let user = this.members[index]
                      result.push({
                        type: 1,
                        atUser: {
                          userId: user.userId,
                          nickName: user.nickName
                        }
                      })
                    } else {
                      if (userName.length) {
                        result.push({
                          type: 2,
                          content: userName
                        })
                      }
                    }
                  })
                } else {
                  result.push({
                    type: 2,
                    content: item
                  })
                }
              }
              return result
            }, [])
            params.content = JSON.stringify(infoList)
            params.contentType = 2 // 字符串类型
          }
          // 1-新增 2-编辑
          if (optType === 1) {
            params.planId = null
          }

          saveWorkPlan(params).then(response => {
            document.getElementById(eleId) ? document.getElementById(eleId).innerText = '' : ''
            this.resetForm(formRef);
            this.addParams.executeUserId = this.managerId
            this.msgSuccess("操作成功");
            this.editPlanVisible = false
            this.refreshWorkPlanList()
            this.$emit('success');
          }).finally(() => {
            loading.close()
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    },
    cancelPlan (item) {
      let thisPlanId = item.planId
      this.$confirm('确认取消该工作计划吗？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({lock: true, text: '加载中', spinner: 'el-icon-loading'});
        cancelWorkPlan({
          id: item.planId
        }).then(response => {
          this.msgSuccess("操作成功");
          this.workPlanList.find((item, index) => {
            if (item.planId === thisPlanId) {
              this.workPlanList.splice(index,1);
              return true
            }
          })
          this.$emit('success');
        }).finally(() => {
          loading.close()
        })
      })
    },
    openPlanDetail (item, optType) {
      // optType: 1-查看详情 2-完成计划
      this.detailOptType = optType
      this.detailParams.planId = item.planId
      if (optType === 1) {
        this.detailModalClose = true
      } else {
        this.detailModalClose = false
      }
      this.resetDetailParam()
      workPlanDetail({id: item.planId}).then(response => {
        this.planDetail = response.data
        this.planDetailVisible = true
      })
    },
    resetDetailParam() {
      this.detailParams.executeContent = ''
      this.detailParams.attachmentFileIds = null
      this.resetForm("detailForm")
    },
    handleFileChange (fileObjs) {
      this.detailParams.attachmentFileIds = fileObjs;
    },
    toTargetDetail(targetId, targetType) {
      window.open("/crm/" + businessTargetTypeToPath(targetType) + "/detail/" + targetId, "_blank")
    },
    editPlan (item) {
      this.editPlanVisible = true
      if (document.getElementById('workPlanContentInfoEdit')) {
        document.getElementById('workPlanContentInfoEdit').innerText = item.plainContent
      } else {
        setTimeout(() => {
          if (document.getElementById('workPlanContentInfoEdit')) {
            document.getElementById('workPlanContentInfoEdit').innerText = item.plainContent
          }
        }, 100)
      }
      this.editParams.content = item.plainContent
      this.editParams.planId = item.planId
      this.editParams.executeUserId = item.executeUserId
      this.editParams.deadline = item.deadline + ':00'
    },
    cancelEdit (item) {
      this.editParams.content = ''
      this.editParams.planId = null
      this.editParams.executeUserId = null
      this.editParams.deadline = null
      this.editParams.contentType = null
      this.resetForm("editForm")
      this.editPlanVisible = false
    },
    cancelComplete () {
      this.planDetailVisible = false
      this.detailParams.planId = null
      this.resetDetailParam()
    },
    confirmComplete () {
      const loading = this.$loading({lock: true, text: '加载中', spinner: 'el-icon-loading'});
      completeWorkPlan(this.detailParams).then(response => {
        this.msgSuccess("操作成功");
        this.planDetailVisible = false
        this.refreshWorkPlanList()
        this.$emit('success');
      }).finally(() => {
        loading.close()
      })
    }
  }
};
</script>

<style lang='scss'>

.el-scrollbar {
  height: 100%;
}

.work-plan {

  font-size: 14px;

  .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .item-info {
    margin-left: 25px;
    padding-right: 20px;

    .el-form-item {
      margin-bottom: 0;
    }

    .el-form-item__label {
      color: #8e8c8c;
    }

    .el-form-item__content {
      font-weight: 700;
    }

    .el-link--inner {
      margin-top: -3px;
    }
  }

  .card-title {
    margin: 0 0 15px 15px;
    border-left: 3px solid #4480F3;
    padding-left: 15px;
    font-size: 17px;
    font-weight: bold;
  }

  .status-btn {
    padding: 4px 7px;
    color: white;
    width: 56px;
    position: relative;
    top: 5px;
  }

  .statusCompleted {
    background-color: #04b95a;
  }

  .statusExecuting {
    background-color: #4480f3;
  }

  .statusCanceled {
    background-color: #b1b1b1;
  }

  .planContent {
    line-height: 1.5em;
    margin-left: 15px;
    font-weight: bold;
    position: relative;
    top: -18px;
    left: 55px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: calc(100% - 260px);
  }

  .completedContent {
    color: gray;
  }

  .contentInfo {
    margin-top: 10px;
    color: gray;
    font-weight: 500;
  }

  .redColor {
    color: red;
  }

  .plan-content {
    margin-bottom: 9px !important;
  }

  .planBtn {
    float: right;
    margin-right: 10px;
  }

  .tip{
    text-align: center;
    color: #909399;
    font-size: 14px;
  }

  .msg-box {
    position: relative;

    .msgInfo {
      width: 100%;
      height: 150px;
      border: 1px solid #aaa;
      border-radius: 6px;
      //padding: 5px 10px 20px;
      line-height: 2;
      white-space: pre-wrap;
      margin-bottom: 10px;
      overflow: auto;
    }

    .word-number {
      position: absolute;
      bottom: 2px;
      right: 20px;
      margin: 0;
      background: #fff;
    }

    .msgInfo:empty:before {
      content: '请输入需要完成的计划内容';
      font-size: 14px;
      color: #bebec3;
    }

    .msgInfo:focus:before {
      content: none;
    }
  }

  .atwho-view {
    top: 1.6em !important;
    left: 0 !important;
    bottom: unset !important;
  }
}
</style>
